<template>
  <div class="videos">
    <b-table
      class="datatable"
      empty-text="Нет данных"
      :fields="columns"
      :items="trailers"
      :striped="true"
      :hover="true"
      :no-local-sorting="false"
      :show-empty="true"
    >
      <template #cell(name)="data">
        <a @click="openModalVideo(data.item.url)" href="#">{{data.item.name}}</a>
      </template>
      <template #cell(createdAt)="data">
          {{ $datetime.formatDateTime(data.item.createdAt) }}
        </template>

      <template #cell(download)="data">
        <a
          :href="data.item.url"
          target="_blank"
          class="trailers__link"
        >download</a>
      </template>
    </b-table>

    <b-modal
      v-if="modalVideo.show"
      centered
      size="xl"
      :visible="true"
      :hide-header="true"
      :hide-footer="true"
      @hidden="closeModalVideo()"
    >
      <div class="h-100 w-100 text-center" @click="closeModalVideo()">
        <video
          :src="modalVideo.url"
          autoplay="true"
          loop="true"
          muted="true"
          controls="true"
        ></video>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  props: {
    trailers: {
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        {
          key: 'name',
          label: 'Название',
        },
        {
          key: 'type',
          label: 'Тип',
        },
        {
          key: 'download',
          label: 'Скачать',
        },
      ],
      modalVideo: {
        show: false,
        trailerUrl: null,
      },
    };
  },
  methods: {
    openModalVideo(trailerUrl) {
      this.modalVideo.show = true;
      this.modalVideo.trailerUrl = trailerUrl;
    },

    closeModalVideo() {
      this.modalVideo.show = false;
      this.modalVideo.trailerUrl = null;
    },
  },
};
</script>

<style scoped>
.trailers__thumb {
  max-width: 100px;
}

.trailers__link:not(:first-child)::before {
    color: rgb(0, 0, 0);
    content: "•";
    padding: 0px 3px;
}
/deep/ .modal-content {
  background-color: inherit;
  border: 0;
}
</style>
